<template>
  <div class="drivers-license-component">
    <div class="service-header mb-2 d-flex align-items-center justify-content-between">
      <div>
        <h6 class="fs-6 fw-semibold text-dark mb-1 mt-0">Driver's License Check</h6>
        <p class="text-xs text-muted mb-0 lh-sm">
          Verify driver's license information and driving record.
        </p>
      </div>
    </div>
    
    <div class="row g-2">
      <div class="col-sm-12">
        <label class="form-label text-xs fw-medium text-secondary">Do you possess a driver's license? <span class="text-danger">*</span></label>
        <select class="form-select form-select-sm text-xs" v-model="drivers_license_data.has_drivers_license">
          <option disabled value="">Please select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { API_BASE_URL } from "@/config";
export default {
  name: 'DriversLicense',
  props: {
    service_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      drivers_license_data: {
        id: "",
        has_drivers_license: '',
      },
    }
  },
  methods: {
    validate_drivers_license() {
      if (this.drivers_license_data.has_drivers_license === '') {
        Swal.fire({
          icon: "info",
          title: "Validation Error",
          text: "Please select if you possess a driver's license.",
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        return false;
      }
      return true;
    },
    handle_data_submit(){
      if (this.validate_drivers_license()) {
        this.$emit("update_data", "drivers_license", this.drivers_license_data);
        return true;
      }
      return false;
    },
    fetch_data() {
      const token = localStorage.getItem("token");
      const workflow_id = localStorage.getItem("workflow_id") || null;
      if (!workflow_id) {
        console.error("Workflow ID is not set in localStorage.");
        return;
      }

      const params = new URLSearchParams({
        workflow_id: workflow_id,
        service_id: this.service_id
      });

      fetch(
        `${API_BASE_URL}/verify_api/employee_screening/api/get_sections_by_workflow_client/?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
            if (data.status === "success" && data.data && data.data.sections && data.data.sections.length > 0) {
            // Find the section for Driver's License Check (or use the first section)
            const section = data.data.sections.find(
              s => s.service_name === "Driver's License Check"
            ) || data.data.sections[0];

            // Flatten key_mappings into an object
            let license = {};
            let key_group = {};
            if (
              section &&
              section.key_groups &&
              section.key_groups.length > 0 &&
              section.key_groups[0].key_mappings
            ) {
              key_group = section.key_groups[0];
              section.key_groups[0].key_mappings.forEach(mapping => {
              license[mapping.key_name] = mapping.key_value;
              });
            }
            // Set data
            this.drivers_license_data.id = key_group.id || "";
            // Handle boolean values for has_drivers_license
            if (license.has_drivers_license == "True" || license.has_drivers_license === true) {
              this.drivers_license_data.has_drivers_license = "yes";
            } else if (license.has_drivers_license == "False" || license.has_drivers_license === false) {
              this.drivers_license_data.has_drivers_license = "no";
            } else {
              this.drivers_license_data.has_drivers_license = license.has_drivers_license || "";
            }
          } else {
            // Reset fields if no data
            this.drivers_license_data = {
              id: "",
              has_drivers_license: '',
            };
          }
        })
        .catch((error) => {
          console.error("Error fetching driver's license data:", error);
        });
    },
  },
  mounted() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.service-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f3f4;
}
</style>
